import { put } from 'redux-saga/effects'
import I18nActions from '../Redux/I18nRedux'
import I18n from '../i18n/i18n'

export function * setActiveLang () {
  const activeLocale = I18n.currentLocale().toLowerCase()
  const activeLang = activeLocale.indexOf('es') === 0 ? 'es' : 'en'
  yield put(I18nActions.setActiveLang(activeLang))
}